module.exports = __webpack_public_path__ + "img/icon-warning.d4b2d426.svg";